import { emptyObj } from 'util/objects'

export default function selectBase(state) {
  return state.billing || emptyObj
}
